<template>
    <div>
        <protokol-invalid-feedback :errors="validator.fieldErrors('crt')">
            <b-form-group
                label=".crt"
                label-cols="2"
            >
                <b-button v-if="settings.crt" variant="danger" @click="settings.crt = null" size="sm" block>{{ $t('remove') }}</b-button>
                <b-form-file v-model="settings.crt"  v-else/>
            </b-form-group>
        </protokol-invalid-feedback>

        <protokol-invalid-feedback :errors="validator.fieldErrors('pem')">
            <b-form-group
                label=".pem"
                label-cols="2"
            >
            <b-button v-if="settings.pem" variant="danger" @click="settings.pem = null" size="sm" block>{{ $t('remove') }}</b-button>
                <b-form-file v-model="settings.pem" v-else/>
            </b-form-group>
        </protokol-invalid-feedback>

        <b-button variant="success" block @click="save" :disabled="!validator.pass()"> {{ $t('save') }} </b-button>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            settings: null,
            validator: this.$validator()
        }
    },

    watch: {
        settings: {
            handler: function() {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    methods: {
        async save() {
            try {
                let formData = new FormData()

                if (this.settings) {
                    if (this.settings.crt instanceof File) {
                        formData.append('crt', this.settings.crt)
                    }

                    if (this.settings.pem instanceof File) {
                        formData.append('key', this.settings.pem)
                    }
                }

                await this.$integrationApi.post("/invoicing/vpfr/user", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })

                this.$emit('success')
            } catch(error) {
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })

                console.error(error)
            }
        },

        fetchUser() {
            this.$integrationApi.get("/invoicing/vpfr/user").then(resp => {
                const { data } = resp

                this.settings = data.settings || {
                    crt: null,
                    pem: null
                }

                this.validator.validate(this.settings, {
                    default: (model, errors) => {
                        if (!model.crt) errors.add("crt", [this.$t('requiredField')])
                        if (!model.pem) errors.add("pem", [this.$t('requiredField')])
                    }
                })
            }).catch(err => {
                this.settings = {}

                console.error(err)

                if (err.response) {
                    if (err.response.status != 400) {
                        this.$bvToast.toast(this.$t('unexpectedError'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                    }
                }
            })
        }
    },

    mounted() {
        this.fetchUser()
    }
}
</script>